import { render, staticRenderFns } from "./ComplexBorder.vue?vue&type=template&id=6831071c"
import script from "./ComplexBorder.vue?vue&type=script&lang=js"
export * from "./ComplexBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports